import {Box, ProgressBar, type ProgressBarProps, Text} from '@primer/react'

interface SubIssuesProgressBarProps extends ProgressBarProps {
  total: number
  completed: number
  percentCompleted: number
}

const textSx = {
  color: 'fg.subtle',
}
const progressBarSx = {
  flex: 1,
  minWidth: '50px',
}
const constainerSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 2,
  width: '100%',
}

export const SubIssuesProgressBar = ({
  total,
  completed,
  percentCompleted,
  ...progressBarProps
}: SubIssuesProgressBarProps) => (
  <Box aria-label="Sub-issues progress" sx={constainerSx}>
    <Text sx={textSx}>
      {completed} of {total}
    </Text>
    <ProgressBar inline sx={progressBarSx} aria-valuenow={percentCompleted} {...progressBarProps}>
      <ProgressBar.Item progress={percentCompleted} sx={{backgroundColor: 'done.emphasis'}} />
      <ProgressBar.Item progress={100 - percentCompleted} sx={{backgroundColor: 'done.muted'}} />
    </ProgressBar>
    <Text sx={textSx}>{percentCompleted}%</Text>
  </Box>
)

SubIssuesProgressBar.displayName = 'SubIssuesProgressBar'
